import React from 'react';
import { Col, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { previewMaibSubtitle, previewMainBtn } from './PreviewMain.module.css';
import { imgUrlGenerate } from '../../../../helpers';
import { OUR_COFFEE_LINK } from '../../../../utils/constants';
import Image from '../../../../components/UI/Image';

const PreviewMain = () => (
  <Row>
    <Col lg={{ size: 10, offset: 1 }}>
      <h1 className='title-big'>Everything You Love About Coffee</h1>
      <Image className='beans-logo' src={imgUrlGenerate(`Beans_logo.svg`)} alt='Beans logo' />
      <div className={previewMaibSubtitle}>We makes every day full of energy and taste</div>
      <div className={previewMaibSubtitle}>Want to try our beans?</div>
      <Link to={`/${OUR_COFFEE_LINK}/`} className={previewMainBtn}>More</Link>
    </Col>
  </Row>
)

export default PreviewMain